import React, { useState } from "react";
import { Formik } from "formik";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import { TextField } from "@material-ui/core";
import clsx from "clsx";
import * as auth from "../../store/ducks/auth.duck";
import { shallowEqual, useSelector } from 'react-redux';

//GraphQL
import { gql } from 'apollo-boost';
import { useMutation } from '@apollo/react-hooks';

const gqlMutationLogin = gql`
  mutation login($login: String!, $password: String!) {
    login(login: $login, password: $password) {
      token
    }
  }
`;

function Login(props) {
  const { intl } = props;
  const [loading, setLoading] = useState(false);
  const [loadingButtonStyle, setLoadingButtonStyle] = useState({
    paddingRight: "2.5rem"
  });

  const enableLoading = () => {
    setLoading(true);
    setLoadingButtonStyle({ paddingRight: "3.5rem" });
  };

  const disableLoading = () => {
    setLoading(false);
    setLoadingButtonStyle({ paddingRight: "2.5rem" });
  };

  const [mutationLogin] = useMutation(gqlMutationLogin);

  const { branding } = useSelector(
      ({ branding}) => ({
        branding
      }),
      shallowEqual
  );

  return (
    <>
      <div className="kt-login__body">
        <div className="kt-login__form">
          <div className="kt-login__title">
            <h3>
              {branding.software_name}
            </h3>
          </div>

          <Formik
            initialValues={{
              login: "",
              password: ""
            }}
            validate={values => {
              const errors = {};

              if (!values.login) {
                // https://github.com/formatjs/react-intl/blob/master/docs/API.md#injection-api
                errors.login = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD"
                });
              }

              if (!values.password) {
                errors.password = intl.formatMessage({
                  id: "AUTH.VALIDATION.REQUIRED_FIELD"
                });
              }

              return errors;
            }}
            onSubmit={(values, { setStatus, setSubmitting }) => {
              enableLoading();

              mutationLogin({variables: {
                  login: values.login,
                  password: values.password
              }})
                  .then(({data: { login : { token } }}) => {
                    disableLoading();
                    props.login(token);
                  })
                  .catch((data) => {
                    disableLoading();
                    setSubmitting(false);
                    setStatus(
                        intl.formatMessage({
                          id: "AUTH.VALIDATION.INVALID_LOGIN"
                        })
                    );
                  });
            }}
          >
            {({
              values,
              status,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting
            }) => (
              <form
                noValidate={true}
                autoComplete="off"
                className="kt-form"
                onSubmit={handleSubmit}
              >
                {status ? (
                  <div role="alert" className="alert alert-danger">
                    <div className="alert-text">{status}</div>
                  </div>
                ) : (
                    <div>
                      Use suas credenciais de acesso à rede.
                    </div>
                )}

                <div className="form-group">
                  <TextField
                    type="text"
                    label="Usuário"
                    margin="normal"
                    className="kt-width-full"
                    name="login"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.login}
                    helperText={touched.login && errors.login}
                    error={Boolean(touched.login && errors.login)}
                  />
                </div>

                <div className="form-group">
                  <TextField
                    type="password"
                    margin="normal"
                    label="Senha"
                    className="kt-width-full"
                    name="password"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.password}
                    helperText={touched.password && errors.password}
                    error={Boolean(touched.password && errors.password)}
                  />
                </div>

                <div className="kt-login__actions">
                  <button
                    id="kt_login_signin_submit"
                    type="submit"
                    disabled={isSubmitting}
                    className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                      {
                        "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": loading
                      }
                    )}`}
                    style={loadingButtonStyle}
                  >
                    Entrar
                  </button>
                </div>
              </form>
            )}
          </Formik>

        </div>
      </div>
    </>
  );
}

export default injectIntl(
  connect(
    null,
    auth.actions
  )(Login)
);
